import React from 'react';
import Flux from 'lib/flux';

// What's up with d13n?
// This store is responsible for "translating" words like "guests", "tour", etc.
// into custom-defined values for specific guides. In a sense, it works like
// i18n or l10n models. Naming this store I18nStore doesn't seem adequate,
// hence I made up the word "domainification". That's what d13n stands for.
// Somebody please come up with a better name.
const D13nStore = Flux.createStore({
  name: 'd13n',

  getInitialState() {
    return {
      priceable: null,
      priceable_addon: null,
      product: null,
      guide: null,
      the_guide: null,
      guest: null,
      guests: null,
      guest_addon: null,
      guests_addon: null,
    };
  },

  d(label) {
    if (typeof label === 'function') {
      return this[label];
    }
    if (this.state) {
      return this.state.toJS()[label];
    }
    return 'n/a';
  },
});

export default D13nStore;
